export enum PageComponentEnum {
	CAROUSEL = 'carousel',
	HIGHLIGHTED_BLOCK = 'highlighted_block',
	IMAGE_BOX = 'image_box',
	ABOUT_US = 'abouts_us',
	FAQS = 'faqs',
	PARTNERS = 'partners',
	NEWS = 'news',
	FORMS = 'forms',
	SIMPLE_TEXT = 'simple_text',
	VIDEO = 'video',
	MAP = 'map',
	TABLE = 'table',
	SOCIAL_MEDIA = 'social_media',
}
